import React, { useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { FaSpinner } from "react-icons/fa";

const AdminRoute = ({ children }) => {
  const { currentUser, userRole, authLoading, adminSettings, adminSettingsLoading, loadAdminSettings } = useAuth();

  useEffect(() => {
    if (currentUser) loadAdminSettings();
  }, [currentUser, loadAdminSettings]);

  const isAdmin = userRole === "admin";
  const showLoader = authLoading || (currentUser && !isAdmin && adminSettingsLoading);

  if (showLoader) {
    return (
      <div className="h-screen flex flex-col items-center justify-center gap-4 bg-gray-50">
        <FaSpinner className="text-blue-500 text-4xl animate-spin" />
        <p className="text-gray-600 font-semibold text-lg">अनुमतियों की जाँच हो रही है...</p>
      </div>
    );
  }

  if (!currentUser) {
    return (
      <div className="h-screen flex flex-col items-center justify-center gap-4 bg-gray-50 px-4">
        <div className="text-6xl">⛔</div>
        <h1 className="text-2xl font-bold text-red-600">अनुमति नहीं है</h1>
        <p className="text-gray-500 text-center">इस पेज को देखने की आपके पास अनुमति नहीं है।</p>
        <a href="/" className="mt-2 px-6 py-2 bg-blue-600 text-white rounded-xl font-semibold hover:bg-blue-700 transition">
          होम पर जाएं
        </a>
      </div>
    );
  }

  if (isAdmin) {
    return children;
  }

  const permData = adminSettings.postingPermissions || {};
  let isAllowed = false;

  for (const key in permData) {
    if (
      Array.isArray(permData[key]) &&
      (permData[key].includes(userRole) || permData[key].includes("all_users"))
    ) {
      isAllowed = true;
      break;
    }
  }

  if (!isAllowed) {
    return (
      <div className="h-screen flex flex-col items-center justify-center gap-4 bg-gray-50 px-4">
        <div className="text-6xl">⛔</div>
        <h1 className="text-2xl font-bold text-red-600">अनुमति नहीं है</h1>
        <p className="text-gray-500 text-center">इस पेज को देखने की आपके पास अनुमति नहीं है।</p>
        <a href="/" className="mt-2 px-6 py-2 bg-blue-600 text-white rounded-xl font-semibold hover:bg-blue-700 transition">
          होम पर जाएं
        </a>
      </div>
    );
  }

  return children;
};

export default AdminRoute;